export enum CommodityType {
  DANGEROUS = 'DANGEROUS',
  NON_DANGEROUS = 'NON DANGEROUS',
  OTHER = 'OTHER'
}
